import axios from 'axios';

export async function getFairLeagueTable(league_pk) {


  try {
    const res = await axios({
      method: 'GET',
      url:
        process.env.REACT_APP_API_URL +
        `/api/leaderboards/league/${league_pk}/league_leaderboard/fair/`,

    });
    return res.data;
  } catch (error) {
    return { error: error };
  }
}

